/*eslint-disable*/
export const dev = {
	AEROLOGIX: 'http://localhost:1400/api/v1/',
}


export const prod = {
	AEROLOGIX: 'https://api.aerologix.com/api/v1/',
}
